<script>
import { eventBus } from "../main";
import { Carousel, Slide } from "vue-carousel";
import navigation from "../mixins/navigation.js";

export default {
  mixins: [navigation],
  name: "app",
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      last: "P_42",
      next: "P_44",
      topic:
        "Estás en: Taller ¿Qué es crédito? / ¡Quiero conocer el tipo de crédito ideal para mí!",
      sent: false,
      credits: [
        {
          descripcion: "Crédito hipotecario",
          src: "https://via.placeholder.com/140x100",
          link: "https://www.bbva.mx/personas/productos/creditos.html#creditos-hipotecarios",
          checked: false,
        },
        {
          descripcion: "Crédito automotriz",
          src: "https://via.placeholder.com/140x100",
          link: "https://www.bbva.mx/personas/productos/creditos/credito-auto.html",
          checked: false,
        },
        {
          descripcion: "Crédito vía nómina",
          src: "https://via.placeholder.com/140x100",
          link: "https://www.bbva.mx/personas/productos/creditos/prestamos-personales/prestamo-nomina.html",
          checked: false,
        },
        {
          descripcion: "Crédito PyME",
          src: "https://via.placeholder.com/140x100",
          link: "https://www.bbva.mx/empresas/productos/financiamiento/creditos-a-corto-y-largo-plazo/credito-pyme.html",
          checked: false,
        },
        {
          descripcion: "Tarjeta de crédito",
          src: "https://via.placeholder.com/140x100",
          link: "https://www.bbva.mx/personas/productos/tarjetas-de-credito.html",
          checked: false,
        },
        {
          descripcion: "Crédito al consumo",
          src: "https://via.placeholder.com/140x100",
          link: "https://www.bbva.mx/personas/productos/creditos/prestamos-personales/prestamo-personal-inmediato.html",
          checked: false,
        }
      ],
      income: 0,
      selected_goals: [],
      selected_amounts: [],
      amount_options: [
        'Crédito menor a $10,000',
        'Crédito de $10,000 a $100,000',
        'Crédito de $100,000 a $500,000',
        'Crédito de $500,000 o más'
      ],
      amount_filters: {
        'Crédito menor a $10,000':[3,4,5],
        'Crédito de $10,000 a $100,000':[3,4,5,6],
        'Crédito de $100,000 a $500,000':[1,2,4,5,6],
        'Crédito de $500,000 o más':[1,2,4]
      },
      selected_periods:[],
      period_options:[
        '6 meses', 
        '12 meses',
        '36 meses',
        '48 meses',
        '60 meses o más'
      ],
      period_filters: {
        '6 meses': [3,5,6],
        '12 meses': [2,3,4,5,6],
        '36 meses': [1,2,4,5,6],
        '48 meses': [1,2,4,6],
        '60 meses o más': [1,2]
      },
      credit_goals: [
        {
          name: "Emergencia",
          credit_types: [3,5,6]
        },
        {
          name: "Estudios",
          credit_types: [3,5,6]
        },
        {
          name: "Gastos personales",
          credit_types: [3,5,6]
        },
        {
          name: "Pagar un viaje",
          credit_types: [3,5,6]
        },
        {
          name: "Comprar una casa",
          credit_types: [1]
        },
        {
          name: "Ampliar mi casa ",
          credit_types: [1,3,6]
        },
        {
          name: "Remodelar mi casa",
          credit_types: [1,3,6]
        },
        {
          name: "Comprar un terreno",
          credit_types: [1]
        },
        {
          name: "Comprar un auto",
          credit_types: [2,5,6]
        },
        {
          name: "Iniciar un negocio",
          credit_types: [4,6]
        },
        {
          name: "Remodelar mi negocio",
          credit_types: [4,5,6]
        },
        {
          name: "Ampliar mi negocio",
          credit_types: [4,6]
        },
        {
          name: "Comprar bienes para mi negocio",
          credit_types: [4,5,6]
        },
        {
          name: "Comprar muebles",
          credit_types: [3,5,6]
        },
        {
          name: "Comprar un electrodoméstico",
          credit_types: [3,5,6]
        }
      ],
      filtered_credits: [],
      dialog: false,
      dialogSelect: 1,
      startPage: true,
      endPage: false,
      interaction: {
        id: "TCC.p43",
        questionText: "Test",
        learnerResponse: "",
        correctAnswer: "",
        wasCorrect: true
      }
    };
  },
  computed: {
    carrouselPage(){
      //return this.$refs.carousel.currentPage();
    }
  },
  methods: {
    filter_credits(){
      let f_c = [];
      for(var i = 0; i < this.selected_goals.length; i++) {
        var goal = this.selected_goals[i];

        var credit_types = this.credit_goals[goal].credit_types;
        var amount_filter = this.amount_filters[this.selected_amounts[i]];
        var period_filter = this.period_filters[this.selected_periods[i]];

        let credits_amount = credit_types.filter(x => amount_filter.includes(x));
        let credits_amount_period = credits_amount.filter(x => period_filter.includes(x));
        f_c = [...new Set([...f_c, ...credits_amount_period])];
      }
      this.filtered_credits = f_c.sort();
      
      this.$parent.enlace = this.credits[this.filtered_credits[0]-1].link

    },
    select_goal: function(index) {
      if(!this.selected_goals.includes(index)) {
        this.selected_goals.push(index);
      } else {
        var new_selected_goals = this.selected_goals.filter(function(el) {
          return el != index;
        }); 
        this.selected_goals = new_selected_goals;
      }
      if(this.selected_goals.length > 4) {
        this.selected_goals.shift();
      }
      this.selected_goals.sort();
    },
    selected(index){
      if(this.selected_goals.includes(index)){
        return 'blue lighten-4'
      } else {
        return 'blue lighten-2'
      }
    },
    showDialog(index){
      this.credits[index-1].checked=true; 
      this.dialogSelect = index;
      this.dialog=true
      this.$parent.enlace = this.credits[index-1].link
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    sendResult() {
      this.sent = true;
      // Record interactions
      let interaction = this.interaction;
      let balance_sections = this.balance_sections.map(function(section) {
        let mapItems = section.items.map(function(item) {
          interaction.questionText = section.text + ":" + item.text;
          interaction.learnerResponse = JSON.stringify(item.budget);
          if (item.budget != 0) {
            eventBus.$emit("record_interaction", interaction);
          }
          return { text: item.text, budget: item.budget };
        });
        return { text: section.text, items: mapItems };
      });
      interaction.questionText = "balance";
      interaction.learnerResponse = JSON.stringify(this.balance);
      eventBus.$emit("record_interaction", interaction);
    },
    advancePage() {
      var car = this.$refs.carousel;
      car.advancePage();
      this.startPage = !car.canAdvanceBackward;
      this.endPage = !car.canAdvanceForward;
    },
    returnPage() {
      var car = this.$refs.carousel;
      car.advancePage("backward");
      this.startPage = !car.canAdvanceBackward;
      this.endPage = !car.canAdvanceForward;
    },
  }
};
</script>

<style lang="stylus" >
.VueCarousel-pagination {
  @media screen and (min-width: 960px) {
    position: relative;
    width: 100% !important;
    margin-left: auto;
    margin-right: 0;
    margin-top: 0px;
    z-index: 20 !important;
    text-align: center !important;
  }
}

.input-group--text-field.input-group--dirty:not(.input-group--textarea) label, .input-group--text-field:not(.input-group--single-line).input-group--focused:not(.input-group--textarea) label, .input-group--text-field:not(.input-group--single-line):focus:not(.input-group--textarea) label {
  min-width: 133%; /* This makes label same width as input when transformed above the input */
}
.check
  position absolute 
  bottom 0px
  right 0px

</style>

<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(sm12, md11, lg9, xl7, text-xs-center)
          v-card(flat).centerCard
            breadcrumb(:back='last') {{topic}}
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') TEST
            v-spacer.pt-4
            
            carousel(ref='carousel', :per-page='1', :mousedrag='false', :paginationEnabled='false', paginationColor='#CCCCCC', paginationActiveColor='#004481')
              slide
                v-layout(row, justify-left)
                  v-flex.pa-0.ma-0(text-xs-left)
                    v-btn.white--text.prevslide.text-xs-left(v-if='!startPage', depressed, color='secondary lighten-1', :disabled='false', @click.prevent='returnPage();')
                      v-icon.px-0.mx-0 fas fa-arrow-left
                v-layout(row, justify-right v-if="income!=0")
                  v-flex.pa-0.ma-0(text-xs-right)
                    v-btn.white--text.nextslide.text-xs-right(v-if='!endPage', depressed, color='secondary lighten-1', @click.prevent='advancePage();')
                      v-icon.px-0.mx-0 fas fa-arrow-right
                v-layout(row, justify-start )
                  v-flex(xs12, md6, mr-0, pr-0)
                    v-card.pl-0.ml-0(flat, text-xs-start, color='grey lighten-2')
                      v-img(height='600px', :src='require("@/assets/TCC-L8-Pagina2 A.png")')
                  v-flex(xs12, md6, ml-0, pl-0)
                    v-card.pr-0.mr-0(flat, height='100%', color='grey lighten-3')
                      v-card-text.titulo24Book.text-xs-left.pl-4.pt-5
                        b ¿Te gustaría saber cuál de los créditos se ajusta mejor a tus necesidades y metas?
                      v-card-text.pl-4.py-2.parrafoDestacado14_gray.text-xs-left
                        | Resuelve el siguiente test para descubrirlo.
                      v-card-text.pl-4.pt-4.pb-0.mb-0.titulo24Reg.text-xs-left
                        | Nivel de ingresos mensuales
                      .pl-4.pr-5.mr-5.py-0.my-0
                        v-text-field(v-on:keypress='isNumber(event)', label='', prefix="$", v-model.number='income')
              slide
                v-layout(row, justify-left)
                  v-flex.pa-0.ma-0(text-xs-left)
                    v-btn.white--text.prevslide.text-xs-left(v-if='!startPage', depressed, color='secondary lighten-1', :disabled='false', @click.prevent='returnPage();')
                      v-icon.px-0.mx-0 fas fa-arrow-left
                v-layout(row, justify-right v-if="selected_goals.length>1")
                  v-flex.pa-0.ma-0(text-xs-right)
                    v-btn.white--text.nextslide.text-xs-right(v-if='!endPage', depressed, color='secondary lighten-1', @click.prevent='advancePage();')
                      v-icon.px-0.mx-0 fas fa-arrow-right
                v-layout(row, wrap, justify-start)
                  v-flex(xs12, md6,  mr-0, pr-0)
                    v-card.pl-0.ml-0(flat, text-xs-start, color='grey lighten-2')
                      v-img(height='600px', :src='require("@/assets/TCC-L8-Pagina2 A.png")')
                  v-flex(xs12, md6, ml-0, pl-0)
                    v-card.pr-2.mr-0(flat, height='100%', color='grey lighten-3')
                      v-card-text.titulo24Book.text-xs-left.pl-4.pt-5.pb-0
                        b ¿Qué cosas te gustaría pagar con tu crédito?
                      v-card-text.pl-4.pr-5.mr-5.py-2.parrafoDestacado14_gray.text-xs-left
                        |  Elige entre dos y cuatro opciones
                      v-flex.text-xs-left.pr-4.mr-4
                        v-btn.btn_select(depressed='false' rounded='false' v-for='(goal, index) in credit_goals' :color='selected(index)' @click.prevent="select_goal(index)") {{goal.name}}
                          v-icon.pa-1.green.checkSmall(v-if="selected(index)!='blue lighten-2'" size="10" color="white") fas fa-check

              slide(v-for="(goal, idx) in selected_goals")
                v-layout(row, justify-left)
                  v-flex.pa-0.ma-0(text-xs-left)
                    v-btn.white--text.prevslide.text-xs-left(v-if='!startPage', depressed, color='secondary lighten-1', :disabled='false', @click.prevent='returnPage(); filter_credits();')
                      v-icon.px-0.mx-0 fas fa-arrow-left
                v-layout(row, justify-right v-if="(selected_amounts[idx] && selected_periods[idx])" style="width: 100%")
                  v-flex.pa-0.ma-0(text-xs-right)
                    v-btn.white--text.nextslide.text-xs-right(v-if='!endPage', depressed, color='secondary lighten-1', @click.prevent='advancePage(); filter_credits();')
                      v-icon.px-0.mx-0 fas fa-arrow-right
                v-layout(row, wrap, justify-start style="width: 100%")
                  v-flex(xs12, md6,  mr-0, pr-0)
                    v-card.pl-0.ml-0(flat, text-xs-start, color='grey lighten-2')
                      v-img(height='600px', :src='require("@/assets/TCC-L8-Pagina2 A.png")')
                  v-flex(xs12, md6, ml-0, pl-0)
                    v-card(flat, height='100%', color='grey lighten-3')
                      v-card-text.titulo24Book.text-xs-left.pl-4.pt-5.pr-5
                        b Seleccionaste:
                          v-btn.btn_select.blue.lighten-4(depressed='false' rounded='false')  {{credit_goals[goal].name}}
                      v-card-text.pl-4.pt-4.pb-0.mb-0.titulo24Reg.text-xs-left.pr-5
                        .pr-5 Monto aproximado que necesitas en crédito
                      v-card-text.pr-5
                        v-select.px-5(flat label="Elige una opción..." v-model="selected_amounts[idx]" :items="amount_options" solo)
                      v-card-text.pl-4.pt-4.pb-0.mb-0.titulo24Reg.text-xs-left
                        .pr-5 ¿En cuánto tiempo te gustaría terminar de pagar tu crédito?
                      v-card-text.pr-5
                        v-select.px-5(flat label="Elige una opción..." v-model="selected_periods[idx]" :items="period_options" solo)
              slide
                v-layout(row, justify-left)
                  v-flex.pa-0.ma-0(text-xs-left)
                    v-btn.white--text.prevslide.text-xs-left(v-if='!startPage', depressed, color='secondary lighten-1', :disabled='false', @click.prevent='returnPage();')
                      v-icon.px-0.mx-0 fas fa-arrow-left
                v-layout(row, justify-right)
                  v-flex.pa-0.ma-0(text-xs-right)
                    v-btn.white--text.nextslide.text-xs-right(v-if='!endPage', depressed, color='secondary lighten-1', @click.prevent='advancePage();')
                      v-icon.px-0.mx-0 fas fa-arrow-right
                v-layout(align-center justify-center column v-for='index in filtered_credits', :key='index')
                  v-card.mx-0.my-3.pa-0(flat min-width=320)
                    v-layout.ma-0.pa-0
                      v-flex.ma-0.pa-0(xs4)
                        v-img.mx-0(v-if="credits[index-1].descripcion=='Crédito hipotecario'" height='100', :src="require('@/assets/TCC-L8-Pagina7 A hipotecario.png')")
                          v-icon.pa-2.green.check(v-if="credits[index-1].checked===true" small color="white") fas fa-check
                        v-img.mx-0(v-if="credits[index-1].descripcion=='Crédito automotriz'" height='100', :src="require('@/assets/TCC-L7-Pagina5 B automotriz.png')")
                          v-icon.pa-2.green.check(v-if="credits[index-1].checked===true" small color="white") fas fa-check
                        v-img.mx-0(v-if="credits[index-1].descripcion=='Crédito vía nómina'" height='100', :src="require('@/assets/TCC-L7-Pagina5 B nomina.png')")
                          v-icon.pa-2.green.check(v-if="credits[index-1].checked===true" small color="white") fas fa-check
                        v-img.mx-0(v-if="credits[index-1].descripcion=='Crédito PyME'" height='100', :src="require('@/assets/TCC-L7-Pagina5 B PyME.png')")
                          v-icon.pa-2.green.check(v-if="credits[index-1].checked===true" small color="white") fas fa-check
                        v-img.mx-0(v-if="credits[index-1].descripcion=='Tarjeta de crédito'" height='100', :src="require('@/assets/TCC-L8-Pagina7 A credito.png')")
                          v-icon.pa-2.green.check(v-if="credits[index-1].checked===true" small color="white") fas fa-check
                        v-img.mx-0(v-if="credits[index-1].descripcion=='Crédito al consumo'" height='100', :src="require('@/assets/TCC-L8-Pagina7 A consumo.png')")
                          v-icon.pa-2.green.check(v-if="credits[index-1].checked===true" small color="white") fas fa-check
                      v-flex.ma-0.pa-0(xs8 @click="showDialog(index)")
                        v-card-text.mx-0.pa-2.pt-4.titulo24RegGrey {{credits[index-1].descripcion}}
                        v-btn.mx-2(fab dark v-ripple color="secondary")
                          v-icon fas fa-plus
                        span.secondary--text(v-ripple)
                          b Ver Características

            v-layout(row, justify-center)
              v-flex
                v-btn.btn(v-if='endPage' color='accent', style='z-index:2', @click.prevent="nextPage(next)")
                  | Siguiente
                v-dialog(v-model='dialog', max-width='930px', content-class="dialog_over")
                  v-layout(row, justify-center)
                    v-flex(text-xs-center)
                      v-card.pb-4
                        .pt-1.pr-2
                          v-layout(row, justify-center)
                            v-flex(text-xs-center)
                              img.dialog_img(src='@/assets/ManoOk.png')
                          v-spacer.my-1.py-4
                          v-card-text.headline
                            | {{credits[dialogSelect-1].descripcion}} 
                        v-card.px-5.questionCard(justify-center, flat)
                          .pt-1.px-5.text-sm-left(v-if="dialogSelect==1")
                            .bt Características:
                            ul.b
                              li.b Te permite adquirir un patrimonio como casa, terreno o departamento. 
                              li.b Las propiedades pueden aumentar su valor. 
                              li.b La propiedad actúa como garantía del crédito. 
                              li.b Las tasas de interés hipotecarias son relativamente bajas y puedes acceder a varios esquemas: tasa de interés fija, tasa de interés variable y tasa de interés máxima 
                              li.b Una parte del interés que se paga es deducible de impuestos. 
                              li.b Facilidades para tramitarlo.
                            v-btn.mx-2(fab dark v-ripple color="secondary" href="https://www.bbva.mx/personas/productos/creditos.html#creditos-hipotecarios"  target="_blank")
                              v-icon fas fa-info
                            span.secondary--text(v-ripple)
                              a(href="https://www.bbva.mx/personas/productos/creditos.html#creditos-hipotecarios"  target="_blank") Conoce más
                          .pt-1.px-5.text-sm-left(v-if="dialogSelect==2")
                            .bt Características:
                            ul.b
                              li.b Te permite adquirir un auto sin tener que pagar el costo total en ese momento. 
                              li.b El desembolso inicial es menor; el enganche de un automóvil puede ser alrededor del 20% del valor del automóvil. 
                              li.b Puedes ajustar las variables del crédito según el tipo de vehículo que te gustaría, dependiendo de tu nivel de ingresos o del valor del auto: Puedes elegir distintos plazos, y puedes pedir una mayor línea de crédito. 
                              li.b El crédito se liquida poco a poco mediante pagos mensuales. 
                              li.b El seguro generalmente se incluye en la mensualidad.  
                            v-btn.mx-2(fab dark v-ripple color="secondary" href="https://www.bbva.mx/personas/productos/creditos/credito-auto.html" target="_blank")
                              v-icon fas fa-info
                            span.secondary--text(v-ripple)
                              a(href="https://www.bbva.mx/personas/productos/creditos/credito-auto.html" target="_blank") Conoce más
                          .pt-1.px-5.text-sm-left(v-if="dialogSelect==3")
                            .bt Características:
                            ul.b
                              li.b Puedes usarlo para adquirir múltiples bienes y/o servicios. 
                              li.b Es útil para enfrentar emergencias e imprevistos. 
                              li.b La mayoría de los bancos otorgan el préstamo de forma inmediata sin necesidad de garantía o aval ya que te respalda la estabilidad del depósito de tu nómina. 
                              li.b Las tasas de interés son más atractivas comparadas con otros créditos. 
                              li.b Es útil para iniciar tu reporte de crédito. 
                            v-btn.mx-2(fab dark v-ripple color="secondary" href="https://www.bbva.mx/educacion-financiera/creditos/ventajas-al-contratar-un-credito-de-nomina-al-iniciar-el-ano.html" target="_blank")
                              v-icon fas fa-info
                            span.secondary--text(v-ripple)
                              a(href="https://www.bbva.mx/educacion-financiera/creditos/ventajas-al-contratar-un-credito-de-nomina-al-iniciar-el-ano.html" target="_blank") Conoce más
                          .pt-1.px-5.text-sm-left(v-if="dialogSelect==4")
                            .bt Características:
                            ul.b
                              li.b Puedes financiar el capital de trabajo de tu negocio a mediano plazo. 
                              li.b Te permite adquirir activos fijos o equipamiento para tu negocio. 
                              li.b Puedes asegurar que tu negocio tenga flujo suficiente a corto plazo. 
                              li.b La tasa de interés es relativamente baja. 
                            v-btn.mx-2(fab dark v-ripple color="secondary" href="https://www.bbva.mx/empresas/productos/financiamiento/creditos-a-corto-y-largo-plazo/credito-pyme.html" target="_blank" )
                              v-icon fas fa-info
                            span.secondary--text(v-ripple)
                              a(href="https://www.bbva.mx/empresas/productos/financiamiento/creditos-a-corto-y-largo-plazo/credito-pyme.html" target="_blank") Conoce más
                          .pt-1.px-5.text-sm-left(v-if="dialogSelect==5")
                            .bt Características:
                            ul.b
                              li.b Puedes usarla para adquirir múltiples bienes y/o servicios. 
                              li.b Es útil para enfrentar emergencias e imprevistos. 
                              li.b El trámite es rápido y sencillo. 
                              li.b Es útil para iniciar tu reporte de crédito. 
                            v-btn.mx-2(fab dark v-ripple color="secondary" href="https://www.bbva.mx/personas/productos/tarjetas-de-credito.html" target="_blank")
                              v-icon fas fa-info
                            span.secondary--text(v-ripple)
                              a(href="https://www.bbva.mx/personas/productos/tarjetas-de-credito.html" target="_blank") Conoce más
                          .pt-1.px-5.text-sm-left(v-if="dialogSelect==6")
                            .bt Características:
                            ul.b
                              li.b Es solicitado por un consumidor para financiar la adquisición de bienes y servicios para uso no profesional. 
                              li.b Se puede solicitar en los propios establecimientos vendedores de bienes y servicios. 
                              li.b La tasa de interés puede ser más elevada que con otros tipos de crédito. 
                              li.b La variedad de cosas que puede adquirir con este tipo de financiamiento es muy amplia. 
                            v-btn.mx-2(fab dark v-ripple color="secondary" href="https://www.bbva.mx/personas/productos/creditos/prestamos-personales/prestamo-personal-inmediato.html" target="_blank")
                              v-icon fas fa-info
                            span.secondary--text(v-ripple)
                              a(href="https://www.bbva.mx/personas/productos/creditos/prestamos-personales/prestamo-personal-inmediato.html" target="_blank") Conoce más
                        v-btn.btn.dialog_btn(color='accent ', @click.prevent="dialog=false") Cerrar
          l-progress(:value='this.$parent.currentPage')
</template>

<style lang="stylus"> 

.checkSmall
  position absolute !important;
  bottom 11px !important;
  right -16px !important;
</style>